import { render, staticRenderFns } from "./PolizaInfoIndex.vue?vue&type=template&id=06604b09&"
import script from "./PolizaInfoIndex.vue?vue&type=script&lang=js&"
export * from "./PolizaInfoIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports